var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',_vm._b({attrs:{"value":_vm.field.value,"vuetify-options":_vm.field.fieldOptions,"text-field-class":"vd-form-input"},on:{"change":_vm.emitChangeEvent}},'DatePicker',_vm.field.fieldOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }